import React from 'react'
import makeStyles from '@material-ui/core/styles/makeStyles'
import styles from '../../../styles'
import { FormattedMessage } from 'react-intl'
import classNames from 'classnames'
import { Avatar, ButtonBase } from '@material-ui/core'
import { useMediaQuery } from 'react-responsive'
import { connect } from 'react-redux'
import { displayModal } from '../../reducers/modal/actions'
import { modalTypes } from '../../../enums/modalTypeEnum'
import YFDisplay from '../../yf_popin/YFDisplay'
import { typeYfDisplay } from '../../../enums/yfManagerEnums'

const useStyle = makeStyles((theme) => ({
        ...styles(theme),
        faqFooterStyle: {
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column',
            justifyContent: 'center',
            textAlign: 'center'
        },
        faqFooterLargeScreenStyle: {
            height: 312
        },
        faqFooterSmallScreenStyle: {
            height: 212
        },

        buttons: {
            justifyContent: 'center'
        },

        largeButtons: {
            justifyContent: 'center',
            height: 48,
            padding: '15px 24px'
        },
        smallButtons: {
            justifyContent: 'center',
            height: 38,
            padding: '15px 14px'
        },
        request: {
            backgroundColor: theme.palette.dynamicGreenToWhite.main,
            '& span': {
                color: theme.palette.textAccessibility.main
            },
            marginRight: 21
        },

        contact: {
            backgroundColor: 'white',
            '& span': {
                color: theme.palette.accessibility.main
            }
        },

        subTitleLargeScreen: {
            marginTop: 28,
            marginBottom: 34
        },
        subTitleSmallScreen: {
            marginTop: 18,
            marginBottom: 24
        },

        imgStyle: {
            backgroundColor: theme.palette.blue['10'], position: 'absolute',
            marginLeft: 'auto',
            marginRight: 'auto',
            left: '50%',
            right: '50%',

            transform: 'translate(-50%, -50%)'
        },
        imgLargeScreen: {
            width: 96,
            height: 96,
            '& svg': {
                fill: theme.palette.blue.main,
                width: 76,
                height: 76
            },
            '& img': {
                width: 96,
                height: 96
            }
        },
        imgSmallScreen: {
            height: 66,
            width: 66,
            '& svg': {
                fill: theme.palette.blue.main,
                width: 46,
                height: 46
            },
            '& img': {
                width: 66,
                height: 66
            }
        }
    }
))

interface Store {
    displayModal: (modalType: string) => void
}

const FaqFooter: React.FC<Store> = (
    {
        displayModal
    }
) => {
    const classes = useStyle()
    const isLargeScreen = useMediaQuery(
        {
            query: '(min-width: 1025px)'
        }
    )

    const faqFooterStyle = classNames(
        isLargeScreen ? [classes.faqFooterLargeScreenStyle] : [classes.faqFooterSmallScreenStyle],
        classes.faqFooterStyle,
        classes.backgroundBlue
    )

    const titleFooter = classNames(
        isLargeScreen ? [classes.title2] : [classes.title4],
        classes.colorWhite
    )

    const subTitleFooter = classNames(
        isLargeScreen ? [classes.text1] : [classes.text2],
        isLargeScreen ? [classes.subTitleLargeScreen] : [classes.subTitleSmallScreen],
        classes.colorWhite
    )

    const textButton = classNames(
        isLargeScreen ? [classes.text2] : [classes.text3]
    )

    const textRequestButton = classNames(
        isLargeScreen ? [classes.largeButtons] : [classes.smallButtons],
        classes.request
    )

    const textContactButton = classNames(
        isLargeScreen ? [classes.largeButtons] : [classes.smallButtons],
        classes.contact
    )

    const imgClass = classNames(
        classes.imgStyle,
        isLargeScreen ? [classes.imgLargeScreen] : [classes.imgSmallScreen]
    )

    return (
        <div>
            <Avatar className={imgClass}>
                <YFDisplay type={typeYfDisplay.REQUEST}/>
            </Avatar>
            <div className={faqFooterStyle}>
	            <span
                    className={titleFooter}
                >
					<FormattedMessage
                        id="faq.no_answer"
                        defaultMessage="Vous n’avez pas trouvé de réponses ?"
                        description="Faq footer title text"
                    />
				</span>
                <span
                    className={subTitleFooter}
                >
					<FormattedMessage
                        id="faq.ask"
                        defaultMessage="Posez-nous directement votre question"
                        description="Faq footer subtitle text"
                    />
				</span>
                <div className={classes.buttons}>
                    <ButtonBase className={textRequestButton} onClick={() => displayModal(modalTypes.demandes)}>
	                    <span
                            className={textButton}
                        >
	                       <FormattedMessage
                               id="faq.request"
                               defaultMessage="Déposer une demande"
                               description="Faq request text"
                           />
	                    </span>
                    </ButtonBase>
                    <ButtonBase className={textContactButton} onClick={() => displayModal(modalTypes.youFirstManager)}>
	                    <span
                            className={textButton}
                        >
	                       <FormattedMessage
                               id="faq.contact"
                               defaultMessage="Nous contacter"
                               description="Faq contact text"
                           />
	                    </span>
                    </ButtonBase>
                </div>
            </div>
        </div>
    )
}

const mapDispatchToProps = {
    displayModal
}

export default connect(undefined, mapDispatchToProps)(FaqFooter)
